import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/select-module")({
	beforeLoad: ({ context }) => {
		const roles = (context as { roles?: string[] }).roles ?? []
		// Platform staff land on /admin/tenants — that's their primary work surface.
		// Regular tenant users land on /stonelog.
		if (roles.includes("platform_admin") || roles.includes("platform_operator")) {
			throw redirect({ to: "/admin/tenants" })
		}
		throw redirect({ to: "/stonelog" })
	},
	component: () => null,
})
